import config from "../config/config";
import { DeploymentPermission } from "../models/types";

export const getBaseDeploymentUrl = () => {
  return `${config.gatewayUrl}/deployment?id=`;
};

export const DeploymentPermissionLabels: Record<DeploymentPermission, string> = {
  [DeploymentPermission.EVERYONE]: "Everyone",
  [DeploymentPermission.ONLY_ME]: "Only Me",
  [DeploymentPermission.SPECIFIC_ROLES]: "Specific Roles",
};

export const DeploymentPermissionValues: Record<string, DeploymentPermission> = {
  Everyone: DeploymentPermission.EVERYONE,
  "Only Me": DeploymentPermission.ONLY_ME,
  "Specific Roles": DeploymentPermission.SPECIFIC_ROLES,
};
